module.exports = __webpack_public_path__ + "img/frame (155).034e3b77.jpg";